import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles(() => ({
	spacer: {
		height: "1px",
		margin: "16px 0",
		border: "solid 1px #d3d6e0"
	}
}));
